<template>

    <div class="mt-1 small text-info" v-if="product.default_price && product.default_price.tax_exemption_reason">
        {{ product.default_price.tax_exemption_reason }}
    </div>

</template>

<script>
    export default {
        props: [
            'product',
        ],
    }
</script>